import { render, staticRenderFns } from "./AddSiupalSearch.vue?vue&type=template&id=5c636000&scoped=true&"
import script from "./AddSiupalSearch.vue?vue&type=script&lang=js&"
export * from "./AddSiupalSearch.vue?vue&type=script&lang=js&"
import style0 from "./AddSiupalSearch.vue?vue&type=style&index=0&id=5c636000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c636000",
  null
  
)

export default component.exports